import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { CryptocoinService, FiatService } from "@main-services/currency";
import { AccountService } from "@modules/account/services/account.service";
import { Fiat, FiatAdapter } from "@modules/+new/assets/domain/entities/fiat.model";
import { CryptoCoin, CryptoCoinAdapter } from "@modules/+new/assets/domain/entities/cryptocoin.model";

@Injectable({
	providedIn: "any"
})
export class AssetsBridgeService {
	private readonly fiatAdapter: FiatAdapter = new FiatAdapter();
	private readonly cryptoCoinAdapter: CryptoCoinAdapter = new CryptoCoinAdapter();
	public constructor(
		private readonly fiatService: FiatService,
		private readonly cryptocoinService: CryptocoinService,
		private readonly accountService: AccountService
	) {}

	public getFiats$(): Observable<Fiat[]> {
		return of(this.fiatAdapter.adaptMany(this.fiatService.list));
	}

	public getFiatById$(fiatId: number): Observable<Fiat> {
		return of(this.fiatAdapter.adapt(this.fiatService.getItemById(fiatId?.toString())));
	}

	public getDefaultFiat$(): Observable<Fiat> {
		return of(this.fiatAdapter.adapt(this.accountService.getDefaultFiat()));
	}

	public getCryptoCoins$(): Observable<CryptoCoin[]> {
		return of(this.cryptoCoinAdapter.adaptMany(this.cryptocoinService.list));
	}
}
